// Click-to-load for YouTube iframes in product custom-liquid blocks.
// sections/main-product.liquid moves their src to data-custom-yt-src; this shows the video's thumbnail
// with a play button and loads the YouTube player (about 1 MB of script) only when a shopper taps it.

const STYLE_ID = 'custom-yt-facade-style';

function addStyles() {
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = `
    .custom-yt-facade { position: relative; display: block; width: 100%; aspect-ratio: 16 / 9; margin: 0; padding: 0; border: 0; cursor: pointer; background: #000 center / cover no-repeat; }
    .custom-yt-facade__play { position: absolute; top: 50%; left: 50%; width: 68px; height: 48px; margin: -24px 0 0 -34px; border-radius: 12px; background: rgba(33, 33, 33, 0.8); transition: background-color 0.2s; }
    .custom-yt-facade:hover .custom-yt-facade__play, .custom-yt-facade:focus-visible .custom-yt-facade__play { background: #f00; }
    .custom-yt-facade__play::before { content: ""; position: absolute; top: 50%; left: 50%; margin: -10px 0 0 -6px; border-style: solid; border-width: 10px 0 10px 17px; border-color: transparent transparent transparent #fff; }
  `;
  document.head.appendChild(style);
}

function videoId(src) {
  const match = src.match(/\/embed\/([\w-]{6,})/);
  return match ? match[1] : null;
}

function makeFacade(iframe) {
  const src = iframe.dataset.customYtSrc;
  iframe.removeAttribute('data-custom-yt-src');
  const id = videoId(src);
  if (!id) {
    iframe.src = src;
    return;
  }

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'custom-yt-facade';
  button.setAttribute('aria-label', iframe.title ? `Play video: ${iframe.title}` : 'Play video');
  button.style.backgroundImage = `url("https://i.ytimg.com/vi/${id}/hqdefault.jpg")`;
  button.innerHTML = '<span class="custom-yt-facade__play" aria-hidden="true"></span>';
  button.addEventListener(
    'click',
    () => {
      const url = new URL(src, window.location.href);
      url.searchParams.set('autoplay', '1');
      iframe.src = url.toString();
      iframe.style.removeProperty('display');
      button.remove();
      iframe.focus();
    },
    { once: true }
  );

  iframe.style.display = 'none';
  iframe.before(button);
}

addStyles();
document.querySelectorAll('iframe[data-custom-yt-src]').forEach(makeFacade);

